export default __webpack_public_path__ + "static/media/ans7.f02d5ee2.png";